import { defineMessages } from '@/shared/i18n/define';

export const bridgeMsgs = defineMessages(
  'apiBridge',
  {
    sesionVencida: 'Tu sesión venció. Entra de nuevo para seguir sincronizando tus datos.',
    servidorFalla:
      'El servidor tuvo un problema. Tus datos están a salvo; reintenta en unos minutos.',
  },
  {
    sesionVencida: 'Your session expired. Sign in again to keep your data in sync.',
    servidorFalla: 'The server had a problem. Your data is safe; try again in a few minutes.',
  },
);
